import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const PostSurgicalService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Joint replacement surgery recovery', 'ACL/PCL reconstruction', 'Spinal surgery rehabilitation', 'Cardiac surgery recovery', 'Abdominal surgery recovery', 'Arthroscopic surgery rehab', 'Fracture fixation recovery', 'Tendon repair rehabilitation'];
  const equipment = ['CPM machines', 'Exercise equipment', 'TENS/IFT therapy', 'Ultrasound therapy', 'Manual therapy techniques'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Post-Surgical Rehabilitation</h1>
          <p className="service-subtitle">Comprehensive recovery programs after surgery</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Post-Surgical Rehabilitation?</h2>
            <p>Post-surgical physiotherapy is crucial for optimal recovery after surgery. We work closely with surgeons to provide appropriate rehabilitation that promotes healing, restores function, and prevents complications.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}><CheckCircle size={20} /><span>{condition}</span></li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We follow your surgeon's protocols while creating a personalized rehabilitation program. Treatment progresses through phases - from early mobility and pain management to strengthening and return to normal activities.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>When should I start physiotherapy after surgery?</AccordionTrigger>
                <AccordionContent>Timing depends on your surgery type. Many patients start within days of surgery, while others wait 1-2 weeks. We coordinate with your surgeon for optimal timing.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Will physiotherapy be painful after surgery?</AccordionTrigger>
                <AccordionContent>Some discomfort is normal, but therapy should not cause severe pain. We work within your comfort level while ensuring progress. Communication with your physiotherapist is key.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Do you coordinate with my surgeon?</AccordionTrigger>
                <AccordionContent>Yes, we maintain communication with your surgeon to ensure rehabilitation follows surgical protocols and to update them on your progress.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Can I do physiotherapy at home after surgery?</AccordionTrigger>
                <AccordionContent>Yes, we offer home visit services for post-surgical patients, which is often more convenient and comfortable during early recovery.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PostSurgicalService;